// import { LoadGif } from 'components'
import { MouseEvent } from 'react'
import { logoSmall } from 'assets/Icons'
import { Button } from './style'

interface IButtonProps {
  disabled?: boolean
  children: JSX.Element[] | JSX.Element | string
  onClick?: (_e: MouseEvent<HTMLElement>) => void
  loading?: boolean | string
  icon?: any
  type?: 'button' | 'submit' | 'reset'
  yellow?: boolean
  medium?: boolean
}

export default function BorderButton(props: IButtonProps) {
  const { loading, children, icon, type, onClick, disabled, yellow, medium } =
    props

  return (
    <Button
      onClick={onClick}
      type={type}
      disabled={disabled}
      yellow={yellow}
      medium={medium}
    >
      {icon && !loading ? (
        <img className="icon" src={icon} alt="select icon" />
      ) : null}
      {!loading && children}
      {loading && (
        <img className="loading-icon" src={logoSmall} alt="card icon" />
      )}
    </Button>
  )
}
